export default __webpack_public_path__ + "fonts/inter-latin-500-normal.aa2121933b2f29817134.woff2";